import React from "react";
import { Navigate } from "react-router-dom";


interface CreateProjectProps {}

const ViewSubcontracts: React.FC<CreateProjectProps> = () => {
  return <Navigate to="/get-contracts?view=subcontracts" replace />;
};

export default ViewSubcontracts;
